
import { Vue } from "vue-property-decorator"

export default class Spinner extends Vue {}
